import { createSelector } from 'reselect';
import { orderBy, isEmpty } from 'lodash';
import { DATE_FORMATS } from 'shared/constants';
import moment from 'moment';

const getLocationExamineeCount = state => state.rosters.locationEventExamineeCount;
const getTcEventExamineeCount = state => state.rosters.tcEventExamineeCount;
const getLocEvRescheduleDates = state => state.rosters.locEvRescheduleDates;
const getEvRescheduleDates = state => state.rosters.evRescheduleDates;


const filterExamCategories = (examineeCategoriesCount) => {
  let newList = examineeCategoriesCount.filter(elem =>
    !elem.hideIfZeroFlag || (elem.hideIfZeroFlag && !!elem.capacity) );

  return orderBy(newList, 'displayOrder');
};

const setDatesFilters = (rescheduleDates) => {
  let dateFilters = {};
  orderBy(rescheduleDates,(el)=> moment(el)).forEach((date)=> {
    const formattedLabel = moment(date).format(DATE_FORMATS.monthShortDayYear);
    dateFilters[date] = formattedLabel;
  });
  return dateFilters;
};

export const orderTcEventExamineeCount = createSelector(
  [getTcEventExamineeCount],
  (eventExamineeCount) => filterExamCategories(eventExamineeCount)
);

export const orderLocationExamineeCount = createSelector(
  [getLocationExamineeCount],
  (locationExamineeCount) => filterExamCategories(locationExamineeCount)
);

export const mapLocEvDateFilters = createSelector(
  [getLocEvRescheduleDates],
  (rescheduleDates) => {
    return setDatesFilters(rescheduleDates);
  }
);

export const mapEvDateFilters = createSelector (
  [getEvRescheduleDates],
  (evRescheduleDates) => {
    return setDatesFilters(evRescheduleDates);
  }
)